import api from 'infra/config/api';

export default function getChatService(bookId) {
    const url = `/get-chat.php?book_id=${bookId}`
    return api
    .url(url)
    .get()
    .json();
}